export const checkApiError = params => {
  if (!params || !Object.keys(params).length) return;
  if (window?._weeeTracker) {
    window?._weeeTracker?.pushEvent?.(params);
  } else {
    window.weeeDataLayer = window?.weeeDataLayer || [];
    window.weeeDataLayer?.push(params);
  }
};
